import { render } from "./SessionsTable.vue?vue&type=template&id=07cd0db8&scoped=true"
import script from "./SessionsTable.vue?vue&type=script&lang=js"
export * from "./SessionsTable.vue?vue&type=script&lang=js"

import "./SessionsTable.vue?vue&type=style&index=0&id=07cd0db8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07cd0db8"]])

export default __exports__